import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { pageSchemas } from "@/lib/seo/page-schema";
import { PartnersPage } from "@/components/site/PartnersPage";
import { PARTNERS_META } from "@/content/meta/partners";

const M = PARTNERS_META.bg;

export const Route = createFileRoute("/bg/partners")({
  head: () => ({
    meta: [
      { title: M.title },
      { name: "description", content: M.description },
      { property: "og:title", content: M.title },
      { property: "og:description", content: M.description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://perceptica.com/bg/partners" },
      ...ogImageMeta("bg", "/partners", M.title),
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: M.title },
      { name: "twitter:description", content: M.description },
    ],
    scripts: pageSchemas({ locale: "bg", path: "/partners" }),
  }),
  component: Page,
});

function Page() {
  return <PartnersPage locale="bg" />;
}
